"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unselectedError = exports.closeModal = exports.selectProduct = exports.discardClick = exports.recoverClick = exports.expiredRender = void 0;
const SHARED_PROPS = {
    'Funnel Type': 'Classic',
    'Orderpipe Version': 'New',
    'Orderpipe Test Eligible': true,
};
const getCampaigns = (items) => items.map((item) => item.campaign_name);
const getProductsBy = (items, key) => items.map((item) => item && item[key]);
const getRecovered = (items, list) => items.filter((item) => list[item.product_id]);
const expiredRender = (expired, isHardChoice) => [
    'Recovery Page',
    Object.assign(Object.assign({}, SHARED_PROPS), { 'Interaction Type': 'Page View', 'Cart Size': expired.total_units, 'Cart Products': getProductsBy(expired.item_list, 'item_name'), 'Cart Product IDs': getProductsBy(expired.item_list, 'product_id'), 'Cart Product Family IDs': getProductsBy(expired.item_list, 'product_family_id'), 'Cart Product Operation Code': getCampaigns(expired.item_list), 'Recovery Type': isHardChoice ? 'Hard Choice' : 'Soft Choice', Access: window.location.href }),
];
exports.expiredRender = expiredRender;
const recoverClick = (expired, list, isHardChoice) => {
    const recovered = getRecovered(expired.item_list, list);
    return [
        'Click',
        Object.assign(Object.assign({}, SHARED_PROPS), { 'Interaction Type': 'Click', 'Click Name': 'Recovery Go To Checkout', 'Cart Products': getProductsBy(recovered, 'item_name'), 'Cart Product IDs': getProductsBy(recovered, 'product_id'), 'Cart Product Family IDs': getProductsBy(recovered, 'product_family_id'), 'Recovery Type': isHardChoice ? 'Hard Choice' : 'Soft Choice' }),
    ];
};
exports.recoverClick = recoverClick;
const discardClick = () => [
    'Click',
    Object.assign(Object.assign({}, SHARED_PROPS), { 'Interaction Type': 'Click', 'Click Name': 'Recovery Discard' }),
];
exports.discardClick = discardClick;
const selectProduct = (selected, isHardChoice) => [
    'Click',
    Object.assign(Object.assign({}, SHARED_PROPS), { 'Interaction Type': 'Click', 'Click Name': `Recovery ${selected ? 'Selected' : 'Deselected'} Product`, 'Recovery Type': isHardChoice ? 'Hard Choice' : 'Soft Choice' }),
];
exports.selectProduct = selectProduct;
const closeModal = () => [
    'Click',
    Object.assign(Object.assign({}, SHARED_PROPS), { 'Interaction Type': 'Click', 'Click Name': 'Recovery Close' }),
];
exports.closeModal = closeModal;
const unselectedError = () => [
    'Click',
    Object.assign(Object.assign({}, SHARED_PROPS), { 'Error Name': 'Checkout Unselected', 'Page Name': 'Recovery Page' }),
];
exports.unselectedError = unselectedError;
